<template>
  <el-dialog
    :title="'编辑设备号：' + model.equipment_number"
    :visible.sync="visible"
    :close-on-click-modal="false"
    width="600px"
    @close="$emit('update:show', false)"
    append-to-body
  >
    <el-form
      :model="model"
      :rules="formRules"
      ref="form"
      label-width="100px"
      size="small"
    >
      <el-form-item label="机型分类" prop="item_category_id">
        <item-category-select
          :val="model.item_category_id"
          :category="2"
          @change="model.item_category_id = $event"
        ></item-category-select>
      </el-form-item>

      <el-form-item label="机器型号">
        <el-input
          style="width: 100%"
          size="small"
          v-model="model.machine_type"
          placeholder="请输入设备机器型号"
        ></el-input>
      </el-form-item>

      <el-form-item label="描述">
        <el-input
          style="width: 100%"
          size="small"
          v-model="model.description"
          placeholder="请输入描述"
        ></el-input>
      </el-form-item>
    </el-form>

    <span slot="footer" class="dialog-footer">
      <el-button size="small" @click="visible = false">取 消</el-button>
      <el-button size="small" type="primary" @click="submitForm"
        >确 定</el-button
      >
    </span>
  </el-dialog>
</template>

<script>
import { customerDeviceBatchUpdate } from '@/service/getData'
import ItemCategorySelect from '@/components/select/item_category_select'

export default {
  components: {
    ItemCategorySelect,
  },
  props: {
    model: {
      type: Object,
    },
    show: {
      type: Boolean,
      default: false,
    },
  },
  watch: {
    show() {
      this.visible = this.show
      if (!this.visible) {
        this.$refs.form.resetFields()
      }
    },
  },
  data() {
    return {
      visible: this.show,
      formRules: {
        item_category_id: [
          {
            required: true,
            type: 'integer',
            min: 1,
            message: '请选择设备分类',
            trigger: 'change',
            transform(value) {
              return Number(value)
            },
          },
        ],
      },
      loading: false,
    }
  },
  methods: {
    submitForm() {
      this.$refs.form.validate(async (valid) => {
        if (valid) {
          if (this.model.id > 0) {
            let res = await customerDeviceBatchUpdate(this.model)
            if (res.code == 0) {
              this.$emit('updated', res.data)
            }
          }
          this.visible = false
        } else {
          console.log('error submit!!')
          return false
        }
      })
    },
  },
}
</script>